import { useState } from "react";
import "./Sidebar.css";
import { TbLayoutSidebarLeftExpand } from "react-icons/tb";

import SidebarMain from "./SidebarMain";
import { IconButton } from "../../design-system/components";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <div className="sidebar--wrapper">
      {isCollapsed && (
        <div className="sidebar-expand-rail">
          <IconButton
            label="Expand sidebar"
            size="md"
            onClick={() => setIsCollapsed(false)}
          >
            <TbLayoutSidebarLeftExpand />
          </IconButton>
        </div>
      )}
      <SidebarMain
        isCollapsed={isCollapsed}
        onCollapse={() => setIsCollapsed(true)}
      />
    </div>
  );
};

export default Sidebar;
